package com.example.mystybag.appCore.model.pages

import com.example.mystybag.core.model.HeaderRowVisualModel
import com.example.mystybag.sharedmodels.project.requestModels.merchant.BagAllergenItem
import com.example.mystybag.sharedmodels.project.responseModels.merchant.ProductCategoryModel
import com.example.mystybag.sharedmodels.project.responseModels.merchant.ProductModel

data class BagUIState(
    val header: HeaderRowVisualModel = HeaderRowVisualModel(),
    
    // Basic bag info
    val bagId: Long = 0L,
    val merchantId: Long = 0L,
    val merchantLocationId: Long? = null,
    val merchantTitle: String = "",
    val merchantImageUrl: String? = null,
    val locationCoverUrl: String? = null,
    val merchantAllergens: String? = null,
    val allergens: List<BagAllergenItem> = emptyList(),
    
    // Location info
    val locationTitle: String = "",
    val locationDescription: String? = null,
    val locationAddress: String = "",
    /** Distance from user, e.g. "3.7 km" */
    val distance: String = "",
    /** Opening hours, e.g. "22:00" for "Open until 22:00" */
    val openingHours: String? = null,
    val cityName: String? = null,
    val locationLatitude: Double = 0.0,
    val locationLongitude: Double = 0.0,
    /** Bag display title, e.g. "Movie time Bag" */
    val bagTitle: String? = null,
    
    // Bag details
    val bagsCount: Int = 0,
    val bagsReservationCount: Int = 0,
    val bagsAvailable: Int = 0,
    val priceNormal: Double = 0.0,
    val priceWithDiscount: Double = 0.0,
    val currency: String = "",
    
    // Collection info
    val collectFromIso: String? = null,
    val collectToIso: String? = null,
    val collectWindowLabel: String = "",
    
    // Rating and reviews
    val averageRating: Double = 0.0,
    val reviewCount: Int = 0,
    // These fields represent average ratings for the 4 rating categories
    // The meaning depends on businessCategoryId (see ReviewCategoryConfigs)
    val ratingCategory1: Double = 0.0, // Average rating for first category (varies by business category)
    val ratingCategory2: Double = 0.0, // Average rating for second category (varies by business category)
    val ratingCategory3: Double = 0.0, // Average rating for third category (varies by business category)
    val ratingCategory4: Double = 0.0, // Average rating for fourth category (varies by business category)
    
    // Status flags
    val isSellingFast: Boolean = false,
    val isFavorite: Boolean = false,
    /** Merchant-declared: bag may contain products for persons over 18. */
    val containsProductsForPersonsOver18: Boolean = false,
    
    // Category
    val businessCategoryId: Long? = null,
    val businessCategoryTitle: String? = null,
    val businessCategoryDescription: String? = null,
    
    // What you could get — structured products (name + grams)
    val products: List<ProductModel> = emptyList(),
    /** Catalog categories of the bag's location, used to label product groups. */
    val productCategories: List<ProductCategoryModel> = emptyList(),
    /** Location menu photos to show at the bottom of bag details. */
    val menuPhotoUrls: List<String> = emptyList(),
    
    // Reserve dialog (replaces bottom sheet)
    val showReserveDialog: Boolean = false,
    val reserveQuantity: Int = 1,
    val reserveDialogLoading: Boolean = false,
    val reserveDialogErrorMessage: String = "",
    val checkoutInProgress: Boolean = false,

    // Pickup-now confirmation dialog (shown when user tries to reserve a bag whose pickup window is open)
    val showPickupNowConfirm: Boolean = false,
    /** Estimated walking time in minutes. null when user location is not available. */
    val pickupNowWalkMinutes: Int? = null,
    /** Estimated driving time in minutes. null when user location is not available. */
    val pickupNowDriveMinutes: Int? = null,
    /** True when the user has granted location permission (controls whether travel time block is shown). */
    val pickupNowHasLocationPermission: Boolean = false,

    // Loading state
    val isLoading: Boolean = true
)

